import QRCodeGenerator from "../360View/QRCodeGenerator"

const columns = [
  {
    name: 'Category',
    selector: (row) => row.category,
  },
  {
    name: 'Company',
    selector: (row) => row.company,
  },
  // {
  //   name: 'QR Code',
  //   selector: (row) => <QRCodeGenerator id={row._id} size={50} />,
  // },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
